import $ from 'jquery'

// eslint-disable-next-line no-undef
const object = vnObject

window.addEventListener('load', () => {
  const { href, hash } = window.location

  $.ajax({
    url: object.ajaxUrl,
    type: 'POST',
    dataType: 'JSON',
    data: {
      _ajax_nonce: object.nonce,
      action: 'vn_page_loader',
      href,
      hash,
    },
    beforeSend: () => {},
    success: () => {},
  })

  if (hash === '#cheatlink') {
    $('[data-button-type="pdf"]').removeAttr('data-bs-toggle')
    $('[data-button-type="pdf"]').removeAttr('data-bs-target')
    $('[data-button-type="pdf"]').attr('data-generate-pdf', 'training')
  }
})
